import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Link, Box } from '@mui/material';
import {
  Home as HomeIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';

const Breadcrumbs = ({ items = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!items || items.length === 0) {
    return null;
  }

  const handleClick = (e, href) => {
    e.preventDefault();
    if (href) {
      navigate(href);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs
        separator={<ChevronRightIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-separator': {
            mx: 1,
          },
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          if (isLast || !item.href) {
            return (
              <Typography
                key={index}
                component="span"
                color="text.primary"
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: isLast ? 600 : 400,
                  color: isLast ? 'text.primary' : 'text.secondary',
                }}
              >
                {index === 0 && item.label === 'Home' ? (
                  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                    <HomeIcon fontSize="small" />
                    <span>Home</span>
                  </Box>
                ) : (
                  item.label
                )}
              </Typography>
            );
          }

          return (
            <Link
              key={index}
              color="inherit"
              href={item.href}
              onClick={(e) => handleClick(e, item.href)}
              sx={{
                fontSize: '0.875rem',
                textDecoration: 'none',
                color: 'text.secondary',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                '&:hover': {
                  textDecoration: 'underline',
                  color: 'primary.main',
                },
              }}
            >
              {index === 0 && item.label === 'Home' ? (
                <>
                  <HomeIcon fontSize="small" />
                  <span>Home</span>
                </>
              ) : (
                item.label
              )}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;

